import { useState } from 'react'
import { Col } from 'react-bootstrap'
import { faCog } from '@fortawesome/pro-solid-svg-icons'

import IconButton from 'components/ui/icon-button/IconButton'
import { useField } from '../../../../context'
import styles from './Config.module.scss'
import ConfigModal from './ConfigModal'

interface IProps {
  disabled?: boolean
}

export const Config = ({ disabled = false }: IProps) => {
  const [show, setShow] = useState(false)
  const { value } = useField('reminderNotification')

  return (
    <Col xs={12} sm={2} className="d-flex justify-content-end">
      <IconButton
        icon={faCog}
        className={styles.config}
        onClick={() => {
          setShow(true)
        }}
        disabled={disabled}
      />
      <ConfigModal
        show={show}
        onClose={() => {
          setShow(false)
        }}
        defaultValue={value?.emailBody || ''}
      />
    </Col>
  )
}
